'use client';

import { useMobileAppLinks } from '@/hooks/useMobileAppsLinks';
import { Skeleton } from '@/components/ui/skeleton';
import Image from 'next/image';
import { twMerge } from 'tailwind-merge';

type QrCodeMultiPlatformProps = {
  width?: number;
  height?: number;
  className?: string;
  containerClassName?: string;
  skeletonClassName?: string;
};

const defaultContainerClassName = 'w-[113px] h-[113px] hidden lg:block p-[8px] rounded-[16px] bg-bg-day';
const defaultSkeletonClass = 'w-[113px] h-[113px]';

export const QrCodeMultiPlatform = ({
  width = 113,
  height = 113,
  containerClassName = defaultContainerClassName,
  className = '',
  skeletonClassName = defaultSkeletonClass,
}: QrCodeMultiPlatformProps = {}) => {
  const { isLoading, hasError, data } = useMobileAppLinks();
  const qrImageUrl = typeof data?.qrImageUrl === 'string' ? data.qrImageUrl : undefined;

  if (isLoading || hasError || !qrImageUrl) {
    return <Skeleton className={skeletonClassName} />;
  }

  return (
    <div className={twMerge(defaultContainerClassName, containerClassName)}>
      <Image alt='qr' width={width - 16} height={height - 16} src={qrImageUrl} className={className} />
    </div>
  );
};
